/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { shadowColor } from 'theme/color';
import { Card, Grid, Typography } from '@mui/material';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
// import { fontsize24, poppins500 } from "theme/common.style";
// import KingBedIcon from "@mui/icons-material/Bed";
// import ShowerIcon from "@mui/icons-material/Shower";
// import GarageIcon from "@mui/icons-material/Garage";
import propertyBed from 'assets/svg/propertyBed.svg';
import propertyBath from 'assets/svg/propertyBath.svg';
import propertyCar from 'assets/svg/propertyCar.svg';
import scale from 'assets/svg/scale.svg';
import maintenance from 'assets/svg/maintenance.svg';
// import AspectRatioIcon from "@mui/icons-material/AspectRatio";
// import EngineeringIcon from "@mui/icons-material/Engineering";

import {
  displayFlex,
  displayFlexColumn,
  fontsize12,
  fontsize16,
  fontsize24,
  poppins300,
  poppins400,
  poppins500,
  poppins600,
} from 'theme/common.style';
import {
  auctionData,
  specView,
  specViewHours,
  specViewPropert,
} from './PropertyProfileDetails.Style';
import {
  dayDispContainer,
  dayTextBottom,
  dayTextFont,
  propertyIcon,
  marginTop20,
  auction,
  singleContainer,
} from './PropertyProfile.style';

function PropertySpecDetails(props) {
  return (
    <Card
      variant="outlined"
      style={{
        borderRadius: '8px',
        boxShadow: `0px 1px 8px ${shadowColor}`,
        padding: '30px 20px',
        marginTop: '14px',
      }}
    >
      <Grid>
        <Grid sx={specView}>
          <Grid sx={specViewHours}>
            <RemoveRedEyeOutlinedIcon />
            276 views in 48 Hours
          </Grid>
          <Grid sx={specViewPropert}>Property ID: HZ24</Grid>
        </Grid>
        <Grid sx={auctionData} xs={12} sm={12} md={12} lg={12} xl={12} gap={2}>
          <Grid
            sx={{ ...poppins500, ...fontsize24 }}
            xs={8}
            sm={8}
            md={8}
            lg={8}
            xl={8}
          >
            Auction: On-site 28 September 2022 - 6pm
          </Grid>
          <Grid
            style={{
              justifyContent: 'flex-end',
            }}
            xs={4}
            sm={4}
            md={4}
            lg={4}
            xl={4}
          >
            <Grid sx={{ ...poppins500, ...fontsize24 }}>Next Inspection:</Grid>
          </Grid>
        </Grid>
        <Grid
          sx={{
            ...poppins400,
            fontSize: '20px',
            color: '#666666',
            paddingBottom: '10px',
          }}
        >
          Property Type
        </Grid>
        <Grid
          sx={{
            ...poppins600,
            fontSize: '32px',
          }}
        >
          Single Family Home
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          sx={displayFlex}
          gap={2}
          style={{ paddingTop: '20px' }}
        >
          <Grid sx={{ ...displayFlexColumn, ...singleContainer }}>
            <Typography sx={dayTextFont}>5</Typography>
            <Typography sx={dayTextBottom}>
              <img alt="bed" src={propertyBed} style={propertyIcon} />
              Bedroom
            </Typography>
          </Grid>
          <Grid sx={{ ...displayFlexColumn, ...singleContainer }}>
            <Typography sx={dayTextFont}>5</Typography>
            <Typography sx={dayTextBottom}>
              <img alt="bath" src={propertyBath} style={propertyIcon} />
              Bathroom
            </Typography>
          </Grid>
          <Grid sx={{ ...displayFlexColumn, ...singleContainer }}>
            <Typography sx={dayTextFont}>1</Typography>
            <Typography sx={dayTextBottom}>
              <img alt="car" src={propertyCar} style={propertyIcon} />
              Garage
            </Typography>
          </Grid>
          <Grid sx={{ ...displayFlexColumn, ...singleContainer }}>
            <Typography sx={dayTextFont}>350</Typography>
            <Typography sx={dayTextBottom}>
              <img alt="scale" src={scale} style={propertyIcon} />
              Land Size
            </Typography>
          </Grid>
          <Grid sx={{ ...displayFlexColumn, ...singleContainer }}>
            <Typography sx={dayTextFont}>2015</Typography>
            <Typography sx={dayTextBottom}>
              <img alt="maintanace" src={maintenance} style={propertyIcon} />
              Year Built
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
}

PropertySpecDetails.propTypes = {};

export default PropertySpecDetails;
